// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:992px){.the-personal-addresses__inner{display:flex;flex-wrap:wrap;margin:0 -10px}}.the-personal-addresses__card{margin-bottom:10px}@media only screen and (min-width:992px){.the-personal-addresses__card{flex-basis:50%;max-width:50%;margin-bottom:0;padding:0 10px 20px}}", ""]);
// Exports
module.exports = exports;
